import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                <div className={styles.footerSection}>
                    <h3>Resto-Online</h3>
                    <p>De eenvoudigste manier om jouw klanten online te laten bestellen.</p>
                </div>
                <div className={styles.footerSection}>
                    <h4>Links</h4>
                    <a href="#features">Features</a>
                    <a href="#faq">FAQ</a>
                    <NavLink to="/algemene-voorwaarden">Algemene Voorwaarden</NavLink>
                    <NavLink to="/privacy">Privacybeleid</NavLink>
                </div>
                <div className={styles.footerSection}>
                    <h4>Contact</h4>
                    <a href="mailto:info@brandvisionx.be">info@brandvisionx.be</a>
                    <a href="https://wa.me/32468229087" target="_blank" rel="noopener noreferrer">WhatsApp</a>
                </div>
            </div>
            <div className={styles.footerBottom}>
                <p>&copy; {new Date().getFullYear()} Resto-Online. Alle rechten voorbehouden.</p>
            </div>
        </footer>
    );
};

export default Footer; 